import {createAction, createAsyncAction} from 'typesafe-actions';
import {
    getBannerHostPortParameters,
    getMarketLimit,
    getNotCalculatedStepsParameters,
    getOneFixtureParameters,
    getPlayerInfoParameters,
    getPlayerSettingsParameters,
    getSportsParameters,
    getStepsParameters,
    getTreeFilter,
    getTreeLive,
    getTreeResult,
    postCouponParameters,
    savePlayerSettingsParameters,
} from '../../spirsApi/api-client';
import { couponTypeArray, LiveOrLineType, ResultInfo, SpirsType, TreeType } from './types';
import { CouponEvent, CouponState } from './reducers/couponReducer';
import {
    Category,
    FixtureElement,
    HostPort,
    ThemeInfoType,
    TournamentWithCategoryId, TREE_LIVE_TYPE,
    ViewType
} from '../../models/api/codegen/code';
import {WidgetIdType} from "./reducers/widgetIdReducer";
import { rightPanelTabType } from './reducers/rightPanelReducer';

export const getOneFixtureAsync = createAsyncAction(
    'GET_ONE_FIXTURE_REQUEST',
    'GET_ONE_FIXTURE_SUCCESS',
    'GET_ONE_FIXTURE_FAILURE',
    'GET_ONE_FIXTURE_CANCEL'
)<getOneFixtureParameters, any, string>();

export const getSportsAsync = createAsyncAction(
    'GET_SPORTS_REQUEST',
    'GET_SPORTS_SUCCESS',
    'GET_SPORTS_FAILURE',
    'GET_SPORTS_CANCEL'
)<getSportsParameters, any, string>();


export const getPlayerInfoAsync = createAsyncAction(
    'GET_PLAYER_INFO_REQUEST',
    'GET_PLAYER_INFO_SUCCESS',
    'GET_PLAYER_INFO_FAILURE',
    'GET_PLAYER_INFO_CANCEL'
)<getPlayerInfoParameters, any, string>();

export const getStepsAsync = createAsyncAction(
    'GET_STEPS_REQUEST',
    'GET_STEPS_SUCCESS',
    'GET_STEPS_FAILURE',
    'GET_STEPS_CANCEL'
)<getStepsParameters, any, string>();

export const getNotCalculatedStepsAsync = createAsyncAction(
    'GET_NOT_CALCULATED_STEPS_REQUEST',
    'GET_NOT_CALCULATED_STEPS_SUCCESS',
    'GET_NOT_CALCULATED_STEPS_FAILURE',
    'GET_NOT_CALCULATED_STEPS_CANCEL'
)<getNotCalculatedStepsParameters, any, string>();

export const saveCoupon = createAsyncAction(
    'SAVE_COUPON_REQUEST',
    'SAVE_COUPON_SUCCESS',
    'SAVE_COUPON_FAILURE',
    'SAVE_COUPON_CANCEL'
)<postCouponParameters, any, string>();

export const getPlayerSettings = createAsyncAction(
    'GET_PLAYER_SETTINGS_REQUEST',
    'GET_PLAYER_SETTINGS_SUCCESS',
    'GET_PLAYER_SETTINGS_FAILURE',
    'GET_PLAYER_SETTINGS_CANCEL'
)<getPlayerSettingsParameters, any, string>();

export const savePlayerSettingsAsync = createAsyncAction(
    'SAVE_PLAYER_SETTINGS_REQUEST',
    'SAVE_PLAYER_SETTINGS_SUCCESS',
    'SAVE_PLAYER_SETTINGS_FAILURE',
    'SAVE_PLAYER_SETTINGS_CANCEL'
)<savePlayerSettingsParameters, any, string>();

export const getFavoritesTreeAsync = createAsyncAction(
    'GET_FAVORITES_TREE_REQUEST',
    'GET_FAVORITES_TREE_SUCCESS',
    'GET_FAVORITES_TREE_FAILURE',
    'GET_FAVORITES_TREE_CANCEL'
)<{}, any, string>();

export const getTreeFilterAsync = createAsyncAction(
    'GET_TREE_LINE_REQUEST',
    'GET_TREE_LINE_SUCCESS',
    'GET_TREE_LINE_FAILURE',
    'GET_TREE_LINE_CANCEL'
)<getTreeFilter, any, string>();



export const getTreeResultAsync = createAsyncAction(
    'GET_TREE_RESULT_REQUEST',
    'GET_TREE_RESULT_SUCCESS',
    'GET_TREE_RESULT_FAILURE',
    'GET_TREE_RESULT_CANCEL'
)<getTreeResult, any, string>();

export const getTreeLiveAsync = createAsyncAction(
    'GET_LINE_REQUEST',
    'GET_LINE_SUCCESS',
    'GET_LINE_FAILURE',
    'GET_LINE_CANCEL',
)<getTreeLive, any, string>();

export const getAllTreeAsync = createAsyncAction(
    'GET_ALL_LINE_REQUEST',
    'GET_ALL_LINE_SUCCESS',
    'GET_ALL_LINE_FAILURE',
    'GET_ALL_LINE_CANCEL'
)<{}, any, string>();

export const getTreeRatingAsync = createAsyncAction(
    'GET_LINE_RATING_REQUEST',
    'GET_LINE_RATING_SUCCESS',
    'GET_LINE_RATING_FAILURE',
    'GET_LINE_RATING_CANCEL'
)<{}, any, string>();

export const getBannerHostPortAsync = createAsyncAction(
    'GET_BANNER_HOST_REQUEST',
    'GET_BANNER_HOST_SUCCESS',
    'GET_BANNER_HOST_FAILURE',
    'GET_BANNER_HOST_CANCEL'
)<getBannerHostPortParameters, any, string>();

export const getMarketLimitAsync = createAsyncAction(
    'GET_MARKET_LIMIT_REQUEST',
    'GET_MARKET_LIMIT_SUCCESS',
    'GET_MARKET_LIMIT_FAILURE',
    'GET_MARKET_LIMIT_CANCEL'
)<getMarketLimit, any, string>();

export const getCategoriestAsync = createAsyncAction(
    'GET_CATEGORIEST_REQUEST',
    'GET_CATEGORIEST_SUCCESS',
    'GET_CATEGORIEST_FAILURE',
    'GET_CATEGORIEST_CANCEL'
)<{}, any, string>();



export const SET_FINGERPRINT = createAction("SET_FINGERPRINT", actionCallback => (s: object) => actionCallback(s));

export const clearLiveTree = createAction('CLEAR_LIVE_TREE', action => () => action());

export const clearRatingTree = createAction('CLEAR_RATING_TREE', action => () => action());

export const SET_DEBUG_MODE = createAction('SET_DEBUG_MODE', actionCallback => () => actionCallback(true));

export const SET_WIDGET_ID = createAction('SET_WIDGET_ID', actionCallback => (widget: WidgetIdType) => actionCallback(widget));

export const SHOW_WIDGET = createAction('SHOW_WIDGET', actionCallback => (b: boolean) => actionCallback(b));

export const CLEAR_DISPLAYED_FIXTURE = createAction('CLEAR_DISPLAYED_FIXTURE', actionCallback => (f: FixtureElement) => actionCallback({f}));

export const CATEGORIES = createAction('CATEGORIES', actionCallback => (s: Category[]) => actionCallback({s}));

export const TOURNAMENT = createAction('TOURNAMENT', actionCallback => (s: TournamentWithCategoryId[]) => actionCallback({s}));

export const SWITCH_DISPLAY_PERIOD_MARKETS = createAction('SWITCH_DISPLAY_PERIOD_MARKETS', actionCallback => {
    return (flag: boolean) => actionCallback({flag});
});

export const CHANGE_SELECTED_TOURNAMENT = createAction('CHANGE_SELECTED_TOURNAMENT', actionCallback => {
    return (selectedTournament: TournamentWithCategoryId | null) => actionCallback({selectedTournament});
});

export const UPDATE_BANNER_HOST_PORT = createAction('UPDATE_BANNER_HOST_PORT', actionCallback => {
    return (bannerHostPort: HostPort | null) => actionCallback({bannerHostPort});
});

export const CHANGE_NEED_CONFIRM_DIALOG_SETTINGS = createAction('CHANGE_NEED_CONFIRM_DIALOG_SETTINGS', actionCallback => {
    return (anchorElId: string | null) => actionCallback({anchorElId});
});

export const HIDE_NEED_CONFIRM_DIALOG = createAction('HIDE_NEED_CONFIRM_DIALOG', actionCallback => {
    return () => actionCallback();
});

export const SWITCH_DEFAULT_LINE_STEP = createAction('SWITCH_DEFAULT_LINE_STEP', actionCallback => (v: boolean) => actionCallback(v));
export const SWITCH_DEFAULT_LIVE_STEP = createAction('SWITCH_DEFAULT_LIVE_STEP', actionCallback => (v: boolean) => actionCallback(v));

// Замесить события (массивом), то есть удалить все старые и добавить новые
export const REPLACE_COUPON_EVENTS = createAction('REPLACE_COUPON_EVENTS', actionCallback => {
    return (couponEvent: Array<CouponEvent>) => actionCallback(couponEvent);
});

// добавить событие в купон
export const ADD_COUPON_EVENT = createAction('ADD_COUPON_EVENT', actionCallback => {
    return (couponEvent: CouponEvent) => actionCallback(couponEvent);
});
// добавить событие во временное хранения для дальнешего подтверждения
export const NEED_CONFIRM_COUPON_EVENT = createAction('NEED_CONFIRM_COUPON_EVENT', actionCallback => {
    return (couponEvent: CouponEvent) => actionCallback(couponEvent);
});
// добавить событие во временное хранения для дальнешего подтверждения
export const REMOVE_NEED_CONFIRM_COUPON_EVENT = createAction('REMOVE_NEED_CONFIRM_COUPON_EVENT', actionCallback => {
    return () => actionCallback();
});
// обновить сообщение под купоном
export const UPDATE_COUPON_MESSAGE = createAction('UPDATE_COUPON_MESSAGE', actionCallback => {
    return (message: string) => actionCallback(message );
});
// показывать сообщение об автоматическом переносе из ординара в экспресс
export const UPDATE_COUPON_TRANSFER_MESSAGE = createAction('UPDATE_COUPON_TRANSFER_MESSAGE', actionCallback => {
    return (show: boolean) => actionCallback(show);
});
// удалить событие из купона
export const REMOVE_COUPON_EVENT = createAction('REMOVE_COUPON_EVENT', actionCallback => {
    return (selectionId: number) => actionCallback({selectionId});
});
// отключить событие в купоне
export const TOGGLE_ACTIVE_STATUS_COUPON_EVENT = createAction('TOGGLE_ACTIVE_STATUS_COUPON_EVENT', actionCallback => {
    return (selectionId: number) => actionCallback({selectionId});
});
// удалить все события из купона
export const REMOVE_ALL_COUPON_EVENTS = createAction('REMOVE_ALL_COUPON_EVENTS');

// установить активную вкладку купона
export const SET_CURRENT_COUPON_TYPE = createAction('SET_CURRENT_COUPON_TYPE', actionCallback => {
    return (couponType: couponType) => actionCallback(couponType);
});

export const SET_COUPON_STATE = createAction('SET_COUPON_STATE', actionCallback => {
    return (state: CouponState) => actionCallback(state);
})

export const COPY_EVENT_TO_COUPON_TYPE = createAction('COPY_EVENT_TO_COUPON_TYPE', actionCallback => {
    return (fixtureId: number, selectionId: number, toType: couponType) => actionCallback({fixtureId, selectionId, toType});
});

export const MOVE_EVENT_TO_COUPON_TYPE = createAction('MOVE_EVENT_TO_COUPON_TYPE', actionCallback => {
    return (fixtureId: number, selectionId: number, toType: couponType) => actionCallback({fixtureId, selectionId, toType});
});

export const SET_RATE_COUPON_EVENT = createAction('SET_RATE_COUPON_EVENT', actionCallback => {
    return (selectionId: number, rate: number) => actionCallback({
        selectionId,
        rate
    });
});

export const SET_RATE_COUPON = createAction('SET_RATE_COUPON', actionCallback => {
    return (rate: number) => actionCallback({rate});
});

// union of all elements at array
export type couponType = typeof couponTypeArray[number];

export const SET_TOKEN = createAction('SET_TOKEN', actionCallback => (token: string) => actionCallback(token));

export const SET_IDENTIFIED = createAction('SET_IDENTIFIED', actionCallback => (identified: boolean) => actionCallback(identified));

export const SET_IDENTIFIED_LOADED = createAction('SET_IDENTIFIED_LOADED', actionCallback => (identifiedLoaded: boolean) => actionCallback(identifiedLoaded));

export const SET_HAS_ACCOUNTS = createAction('SET_HAS_ACCOUNTS', actionCallback => (hasAccounts: boolean) => actionCallback(hasAccounts));

export const SET_ACCOUNTS_LOADED = createAction('SET_ACCOUNTS_LOADED', actionCallback => (loaded: boolean) => actionCallback(loaded));

export const SET_AUTHENTICATED = createAction('SET_AUTHENTICATED', actionCallback => (authenticated: boolean) => actionCallback(authenticated));

export const SET_AUTHENTICATED_LOADED = createAction('SET_AUTHENTICATED_LOADED', actionCallback => (authenticatedLoaded: boolean) => actionCallback(authenticatedLoaded));

export const SET_SPORT_CHL_IN_RESULTS = createAction('SET_SPORT_CHL_IN_RESULTS', actionCallback => (info: ResultInfo) => actionCallback(info));

// выбранная вкладка на странице результатов
export const SET_RESULT_TAB = createAction('SET_RESULT_TAB', actionCallback => (tab: LiveOrLineType) => actionCallback(tab));
export const RETURN_FROM_RESULT = createAction('RETURN_FROM_RESULT', actionCallback => () => actionCallback(true));

// отображение прогрессбара
export const LOADING = createAction('LOADING', actionCallback => () => actionCallback(true));
export const COMPLETE = createAction('COMPLETE', actionCallback => () => actionCallback(false));

// отображение инфорамции на экране
export const CHANGE_VIEW = createAction('CHANGE_VIEW', actionCallback => (v: ViewType) => actionCallback(v));

// модальное окно с купоном для мобильной версии
export const MOBILE_MODAL_COUPON = createAction('MOBILE_MODAL_COUPON', actionCallback => (b: boolean) => actionCallback(b));

export const SELECT_SPORT_MENU = createAction('SELECT_SPORT_MENU', actionCallback => (s: number | 'rating' | 'home' | null) => actionCallback(s));

export const SELECT_CATEGORIES_MENU = createAction('SELECT_CATEGORIES_MENU', actionCallback => (s: number | 'rating' | 'home' | null) => actionCallback(s));

export const SELECT_TOURNAMENT_MENU = createAction('SELECT_TOURNAMENT_MENU', actionCallback => (s: number | 'rating' | 'home' | null) => actionCallback(s));

export const CLEAR_TREE = createAction('CLEAR_TREE', actionCallback => () => actionCallback());

export const SEARCH_VALUE = createAction('SEARCH_VALUE', actionCallback => (s: string) => actionCallback(s));

export const CHANGE_THEME = createAction('CHANGE_THEME', actionCallback => (theme: ThemeInfoType) => actionCallback(theme))

export const SET_FAVORITES_COUNT = createAction('SET_FAVORITES_COUNT', actionCallback => (count: number) => actionCallback(count))


export const SELECT_TIME_PERIOD = createAction('SELECT_TIME_PERIOD', actionCallback => (s: 'ALL' | 'ONE_HOUR' |'TWO_HOURS' | 'FOUR_HOURS' | 'SIX_HOURS' | 'TWELVE_HOURS' | 'ONE_DAY' | 'TWO_DAYS') => actionCallback(s));
export const CHANGE_RIGHT_PANEL_TAB = createAction('CHANGE_RIGHT_PANEL_TAB', actionCallback => (tab: rightPanelTabType) => actionCallback(tab));

export const CHANGE_TREE_TYPE = createAction('CHANGE_TREE_TYPE', actionCallback => (type: TreeType) => actionCallback(type));

export const startTreePolling = createAction('TREE_POLLING_START', actionCallback => ({type, liveType, time}: {type: TreeType, liveType: TREE_LIVE_TYPE, time: SpirsType['timePeriodReducer']}) => actionCallback({type, liveType, time}));

export const stopTreePolling = createAction('TREE_POLLING_STOP', actionCallback => () => actionCallback());

export const emptyTreeAction = createAction("EMPTY_TREE_ACTION", actionCallback => () => actionCallback());